import React from 'react'
import { Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

export const PAGE_SIZE_OPTIONS = [5, 10, 20]

const getStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
    marginBottom: '16px',
  },
  button: {
    minWidth: '56px',
  },
}))

const PageSizeSelector = React.memo((props) => {
  const { perPage, onChange } = props
  const classes = getStyles()

  return (
    <div className={classes.root}>
      <Typography variant="body2">表示件数</Typography>
      {PAGE_SIZE_OPTIONS.map((size) => (
        <Button
          key={size}
          variant={perPage === size ? 'contained' : 'outlined'}
          color="primary"
          size="small"
          className={classes.button}
          onClick={() => onChange(size)}
        >
          {size}件
        </Button>
      ))}
    </div>
  )
})

export default PageSizeSelector
